import dateUtil from './dateUtil';

type Unit = 'year' | 'month' | 'day';

const isSameDate = (isoDateString1: string, isoDateString2: string, unit: Unit = 'day'): boolean => {
  return dateUtil(isoDateString1).isSame(dateUtil(isoDateString2), unit);
};

export default isSameDate;
